import React, { useState } from "react";
import { api, formatApiError } from "@/lib/api";

export default function AdminPasswordSection() {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [msg, setMsg] = useState({ type: "", text: "" });

  const submit = async (e) => {
    e.preventDefault();
    setMsg({ type: "", text: "" });

    if (!current || !next || !confirm) {
      setMsg({ type: "error", text: "Remplis tous les champs." });
      return;
    }
    if (next.length < 8) {
      setMsg({ type: "error", text: "Le nouveau mot de passe doit faire au moins 8 caractères." });
      return;
    }
    if (next !== confirm) {
      setMsg({ type: "error", text: "Les deux nouveaux mots de passe ne correspondent pas." });
      return;
    }

    setSubmitting(true);
    try {
      await api.changePassword(current, next);
      setMsg({
        type: "success",
        text: "Mot de passe changé. Utilise le nouveau pour ta prochaine connexion.",
      });
      setCurrent("");
      setNext("");
      setConfirm("");
    } catch (err) {
      setMsg({ type: "error", text: formatApiError(err) });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section
      className="rounded-3xl p-6 md:p-8"
      style={{ background: "#FFFFFF", border: "1px solid var(--line)" }}
      data-testid="admin-password-section"
    >
      <h2 className="display mb-2" style={{ fontSize: 26, color: "var(--navy)" }}>
        🔐 Changer mon mot de passe
      </h2>
      <p className="text-sm mb-5" style={{ color: "var(--mute)" }}>
        Choisis un mot de passe d'au moins 8 caractères. Tu seras toujours connecté(e) après le changement.
      </p>
      <form onSubmit={submit} className="space-y-3 max-w-md">
        <div>
          <label
            className="text-xs font-bold block mb-1"
            style={{ color: "var(--navy)", letterSpacing: "0.06em", textTransform: "uppercase" }}
          >
            Mot de passe actuel
          </label>
          <input
            type="password"
            value={current}
            onChange={(e) => setCurrent(e.target.value)}
            autoComplete="current-password"
            className="w-full px-3 py-2 rounded-xl border outline-none text-[14px]"
            style={{ borderColor: "#DCE3ED", color: "var(--navy)" }}
            data-testid="pw-current"
            required
          />
        </div>
        <div>
          <label
            className="text-xs font-bold block mb-1"
            style={{ color: "var(--navy)", letterSpacing: "0.06em", textTransform: "uppercase" }}
          >
            Nouveau mot de passe
          </label>
          <input
            type="password"
            value={next}
            onChange={(e) => setNext(e.target.value)}
            autoComplete="new-password"
            className="w-full px-3 py-2 rounded-xl border outline-none text-[14px]"
            style={{ borderColor: "#DCE3ED", color: "var(--navy)" }}
            data-testid="pw-new"
            required
            minLength={8}
          />
        </div>
        <div>
          <label
            className="text-xs font-bold block mb-1"
            style={{ color: "var(--navy)", letterSpacing: "0.06em", textTransform: "uppercase" }}
          >
            Confirmer le nouveau mot de passe
          </label>
          <input
            type="password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            autoComplete="new-password"
            className="w-full px-3 py-2 rounded-xl border outline-none text-[14px]"
            style={{ borderColor: "#DCE3ED", color: "var(--navy)" }}
            data-testid="pw-confirm"
            required
            minLength={8}
          />
        </div>
        {msg.text && (
          <div
            className="text-sm px-3 py-2 rounded-xl"
            style={
              msg.type === "success"
                ? { background: "#DDF6E5", color: "#1A6F3A", border: "1px solid #39C26F30" }
                : { background: "#FFE9EA", color: "#B3263F", border: "1px solid #F5C2C8" }
            }
            data-testid="pw-msg"
          >
            {msg.type === "success" ? "✓ " : "⚠️ "}
            {msg.text}
          </div>
        )}
        <button
          type="submit"
          disabled={submitting}
          className="btn-primary"
          style={{ padding: "10px 20px", fontSize: 14 }}
          data-testid="pw-submit"
        >
          {submitting ? "Changement…" : "🔐 Changer le mot de passe"}
        </button>
      </form>
    </section>
  );
}
